import {Component, Input, OnInit} from '@angular/core';

function cloneValue(value: any): any {
  if (Array.isArray(value)) {
    return value.map(item => cloneValue(item));
  }
  if (value && typeof value === 'object') {
    const result: any = {};
    Object.keys(value).forEach(key => result[key] = cloneValue(value[key]));
    return result;
  }
  return value;
}

@Component({
  selector: 'app-show-content-modal',
  templateUrl: './show-content-modal.component.html',
  styleUrls: ['./show-content-modal.component.scss']
})
export class ShowContentModalComponent implements OnInit {
  @Input() contentData: any = {
    jumpType: 'showContent',
    contentList: []
  };

  public contentList: any[] = [];

  ngOnInit(): void {
    const source = this.contentData || {};
    this.contentList = Array.isArray(source.contentList)
      ? cloneValue(source.contentList) : [];
  }
}
